import { eachDayOfInterval, isBefore, isSaturday, isSunday, startOfDay } from 'date-fns';
import { getMultiDayDates, isSkippedDay } from '@forms/schedules/internal/helpers';
import { MultiDayOptions } from '@forms/schedules/internal/types';
import { MAX_MULTI_DAYS } from '@forms/schedules/internal/constants';

export const getEndDate = (start: Date, days: number, options: MultiDayOptions) =>
  getMultiDayDates(start, days, options).at(-1) as Date;

export const countWorkdays = (start: Date, end: Date, options: MultiDayOptions) => {
  const from = startOfDay(start);
  const to = startOfDay(end);
  if (!isBefore(from, to)) return 1;

  const count = eachDayOfInterval({ start: from, end: to }).filter(
    (day, index) => index === 0 || !isSkippedDay(day, options),
  ).length;
  return Math.min(count, MAX_MULTI_DAYS);
};

export const getTurnedOffStartDay = (start: Date, options: MultiDayOptions) => {
  if (options.skipSaturday && isSaturday(start)) return 'skipSaturday' as const;
  if (options.skipSunday && isSunday(start)) return 'skipSunday' as const;
  return null;
};

export const getDurationUnit = (days: number, options: MultiDayOptions) => {
  if (days === 1) return 'day';
  return options.skipSaturday || options.skipSunday ? 'workdays' : 'days';
};
